<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          class="pt-1 form-input"
          dense
          outlined
          :label="$t('$vuetify.printerConfig.printerName')"
          autofocus
          v-model="settings.name"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" style="margin-top: -2rem">
        <v-text-field
          class="pt-1 form-input"
          dense
          outlined
          :label="$t('$vuetify.printerConfig.ipAddress')"
          v-model="settings.ipAddress"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="margin-top: -2rem">
        <v-text-field
          class="pt-1 form-input"
          dense
          outlined
          :label="$t('$vuetify.printerConfig.networkPrinterName')"
          v-model="settings.printerName"
        >
        </v-text-field>
      </v-col> </v-row
    ><v-row>
      <v-col cols="3" style="margin-top: -2rem">
        <v-select
          class="pt-1 form-input"
          dense
          outlined
          v-model="settings.width"
          :items="widths"
          :label="$t('$vuetify.printerConfig.width')"
          @change="calculateLineLength"
        >
        </v-select>
      </v-col>
      <v-col cols="3" style="margin-top: -2rem">
        <v-select
          :disabled="isA4"
          class="pt-1 form-input"
          dense
          outlined
          v-model="settings.font"
          :items="fonts"
          :label="$t('$vuetify.printerConfig.font')"
          @change="calculateLineLength"
        >
        </v-select>
      </v-col>
      <v-col cols="3" style="margin-top: -2rem">
        <v-select
          :disabled="isA4"
          class="pt-1 form-input"
          dense
          outlined
          v-model="settings.size"
          :items="sizes"
          :label="$t('$vuetify.printerConfig.size')"
          @change="calculateLineLength"
        >
        </v-select>
      </v-col>
      <v-col cols="3" style="margin-top: -2rem">
        <v-text-field
          :disabled="isA4"
          class="pt-1 form-input"
          dense
          outlined
          v-model="settings.lineLength"
          :label="$t('$vuetify.printerConfig.lineLength')"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="right">
        <v-btn text class="btn-secondary" style="margin-right: 1rem" @click="close">{{
          $t("$vuetify.printerConfig.cancel")
        }}</v-btn>
        <v-btn text class="btn-primary" :disabled="!valid" @click="addPrinter">{{
          $t("$vuetify.printerConfig.addPrinter")
        }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from '@/plugins/rules'

export default {
  data () {
    return {
      name: undefined,
      ipAddress: undefined,
      printerName: undefined,
      settings: {
        name: '',
        ipAddress: '',
        port: '',
        printerName: '',
        font: '',
        size: '',
        lineLength: '',
        width: ''
      },
      rules: {
        req: rules.req(),
        eq: rules.eq
      },
      fonts: ['A', 'B', 'C'],
      sizes: [0, 1, 2, 3],
      widths: ['58', '80', 'A4'],
      charTable: null,
      codePage: null,
      euroSymbolType: null
    }
  },

  computed: {
    valid () {
      if (this.isA4) {
        return this.settings.name !== null && this.settings.printerName !== ''
      } else {
        return this.settings.name !== null &&
          this.settings.printerName !== '' &&
          this.settings.width !== '' &&
          this.settings.size !== '' &&
          this.settings.font !== '' &&
          this.settings.lineLength !== ''
      }
    },
    isA4 () {
      return this.settings.width === 'A4'
    }
  },

  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler (newValue, _) {
        if (newValue.width === 'A4') {
          this.settings.font = ''
          this.settings.size = ''
          this.settings.lineLength = ''
        }
      }
    }
  },

  methods: {
    close () {
      this.clearForm()
      this.$emit('close')
    },

    clearForm () {
      this.settings.name = ''
      this.settings.ipAddress = 'https://localhost:18080/WebPrintSDK/'
      this.settings.printerName = ''
      this.settings.width = ''
      this.settings.font = ''
      this.settings.size = ''
      this.settings.lineLength = ''
    },

    addPrinter () {
      const printer = {
        name: this.settings.name,
        ipAddress: this.settings.ipAddress ?? null,
        printerName: this.settings.printerName,
        port: '',
        font: this.settings.font,
        size: this.settings.size,
        lineLength: this.settings.lineLength,
        width: this.settings.width,
        charTable: null,
        codePage: null,
        euroSymbolType: null,
        library: 'BIXOLON'
      }
      this.$emit('addPrinter', printer)
      this.clearForm()
    },

    calculateLineLength () {
      if (this.settings.font !== null && this.settings.size !== null) {
        switch (this.settings.font.toLowerCase()) {
          case 'a':
            switch (this.settings.size) {
              case 0:
                this.settings.lineLength = 48
                break
              case 1:
                this.settings.lineLength = 24
                break
              case 2:
                this.settings.lineLength = 16
                break
              case 3:
                this.settings.lineLength = 12
                break
            }
            break
          case 'b':
          case 'c':
            switch (this.settings.size) {
              case 0:
                this.settings.lineLength = 64
                break
              case 1:
                this.settings.lineLength = 32
                break
              case 2:
                this.settings.lineLength = 21
                break
              case 3:
                this.settings.lineLength = 16
                break
            }
            break
        }
      }
    }
  },
  created () {
    this.settings.ipAddress = 'https://localhost:18080/WebPrintSDK/'
  }
}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F8FAFC !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}
.btn-secondary {
  padding: 11px 20px;
  background: #F8FAFC;
  border: 1.5px solid #E2E8F0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: #334155;
}
</style>
